<!-- ImgSelectItem.vue -->
<template>
  <div class="file-tree-wrapper">
    <div 
      class="file-item"
      :class="{ 
        'folder-item': file.isDirectory,
        'image-item': !file.isDirectory,
        'active': isSelected
      }"
      @click="handleClick"
    >
      
      <!-- 文件夹图标 -->
      <i 
        v-if="file.isDirectory"
        class="file-icon folder-closed"
      ></i>
      
      <!-- 图片文件图标 -->
      <i 
        v-else
        class="file-icon image-file"
      ></i>
      
      <span class="file-name">{{ file.name }}</span>
      
      <!-- 选中状态标记 -->
      <i v-if="isSelected && !file.isDirectory" class="el-icon-check selected-icon"></i>
    </div>
    
  </div>
</template>

<script>

export default {
  name: 'ImgSelectItem',
  props: {
    file: {
      type: Object,
      required: true
    },
    selectedDir: {
      type: String,
      default: '/'
    },
    selectedImgPath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      children: [],
      loading: false,
      isExpanded: false
    }
  },
  computed: {
    fullPath() { // 当前文件项目的完整相对路径, 可以用作项目的唯一标识  
      // 计算完整路径
      const separator = this.selectedDir.endsWith('/') ? '' : '/';
      return this.selectedDir + separator + this.file.name + (this.file.isDirectory ? '/' : '');
    },
    isSelected() {
      // 判断当前文件是否被选中（仅对图片文件）
      return !this.file.isDirectory && this.fullPath === this.selectedImgPath;
    }
  },
  watch: {
  },
  methods: {
    handleClick() {
      if (this.file.isDirectory) {
        // 通知父组件选中此文件夹
        this.$emit('select-dir', {
          currentDir: this.selectedDir,
          fullPath: this.fullPath
        });
      } else {
        // 选中图片文件
        this.$emit('select-img', this.fullPath);
      }
    },
  }
}
</script>

<style scoped>
.file-tree-wrapper {
  width: 100%;
}

.folder-item {
  cursor: pointer;
}

.image-item {
  cursor: pointer;
}

.folder-children {
  padding-left: 20px;
}

.loading-children {
  padding: 5px 10px;
  color: #909399;
  font-size: 12px;
}

.file-icon {
  margin-right: 8px;
  width: 16px;
  height: 16px;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.file-item {
  animation: fadeIn 0.3s ease-out;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  margin-bottom: 1px;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  background: transparent;
  border: none;
  box-shadow: none;
}

.file-item:hover {
  background: rgba(138, 43, 226, 0.05);
  transform: none;
  box-shadow: none;
}

/* 文件夹被选中时的高亮样式 */
.file-item.active.folder-item {
  background: rgba(138, 43, 226, 0.15);
  color: #8a2be2;
}

.file-item.active.folder-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #8a2be2;
  border-radius: 0 2px 2px 0;
}

.file-item.active .file-name {
  color: #8a2be2;
  font-weight: 500;
}

/* 文件名样式 */
.file-name {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  color: #2c3e50;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-item.active .file-name {
  color: #8a2be2;
  font-weight: 500;
}

.file-item:hover .file-name {
  color: #1a2a3a;
}

/* 文件夹关闭状态图标 */
.file-icon.folder-closed {
  background-image: url('@/assets/icons/folder.svg');
}

/* 图片文件图标 */
.file-icon.image-file {
  background-image: url('@/assets/icons/image.svg');
}

/* 选中图标 */
.selected-icon {
  color: #8a2be2;
  font-weight: bold;
  margin-left: 8px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>